<template>
	<div>
		<div class="imagecontainer">
			<img src="../assets/Joinus.png" style="width: 490px;height: 90px;"/>
		</div>
		<div class="imagecontainerone" style="padding-top: 243px;">
			<img src="../assets/are.png" style=" width: 1030px;height: 100px;position: absolute;margin-top: -205px;"/>
		</div>
		
		<div class="imagecontainerone" v-for="(item,index) in tableList" :key="index">
			<div style="margin-left: -500px;display: flex;" :style="index==1||index==2?'margin-left:-390px':'margin-left: -500px'">
				<div>
					<img src="../assets/joinleft.png" style="width: 62px;height: 62px;" v-show="index==0"/>
					<img src="../assets/joinleftone.png" style="width: 62px;height: 62px;" v-show="index==1"/>
					<img src="../assets/joinlefttwo.png" style="width: 62px;height: 62px;" v-show="index==2"/>
					<img src="../assets/joinleftthree.png" style="width: 62px;height: 62px;" v-show="index==3"/>
					<div class="vertical"></div>
				</div>
				<div style="padding-left: 10px;">
					<img src="../assets/joinright.png" style="width: 386px;height: 70px;" :style="index==1 || index==2?'width:497px':'width: 386px'"/>
					<div class="bgcontent">{{item.name}}</div>
				</div>
				<div class="contenbg">
					<div class="downbgcontent" :style="index==3?'padding-top:40px':''">{{item.content}}<span v-show="index==3" style="color: #001BC8;padding-left: 5px;">Support@hello-novel.com</span></div>
				</div>
			</div>
			
		</div>
		
		<nav class="navbar" >
		      <ul class="nav-list" >
		        <li class="nav-item" v-for="(item,index) in tabsList" :key="index" 
				:style="index==0?'border-bottom-left-radius: 21px;border-top-left-radius: 21px;padding-left:100px':index==3?'border-bottom-right-radius: 21px;border-top-right-radius: 21px;padding-right:100px':''">
					<img src="../assets/Group.png" style="width: 166px;height: 48px;"/>
					<div class="about">{{item.name}}</div>
					<div v-show="index==0" class="content" @click="Jump('HelloNovel')">HelloNovel</div>
					<div v-show="index==0" style="margin-top: 10px;" class="content" @click="Jump('Company')">Company</div>
					<div v-show="index==0" style="margin-top: 10px;" class="content">Privacy policy</div>
					<div v-show="index==0" style="margin-top: 10px;" class="content">Terms of service</div>
					<div v-show="index==1" class="content" @click="Jump('Author Recruitment')">Author Recruitment</div>
					<div v-show="index==2" class="content" @click="Jump('Contact Information')">Contact Information</div>
				</li>
				
		      </ul>
		</nav>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				email:'',
				tabsList:[{name:'About us'},{name:'Join us'},{name:'Contact us'},{name:'Stay tuned...'}],
				tableList:[
					{name:'Generous Bonuses',content:'We value your hard work and creativity! Enjoy a diverse range of bonuses that reward your contributions.'},
					{name:'Promotion Opportunities',content:"Stand out and earn the chance to grow your presence with our competitive promotion programs. Your talent won't go unnoticed!"},
					{name:'Active and Supportive Team',content:'Our vibrant, friendly team is always here to assist you, offering the encouragement and help your need to succeed.'},
					{name:'Registration method',content:'Contact Email:'}]
			}
		},
		
		methods:{
			Jump(val){
				this.$emit('message-from-child', val);
			}
		}
	}
</script>

<style scoped="scoped">
	.imagecontainer {
	  display: flex;
	  justify-content: center;
	  padding-top: 20px;
	  
	}
	
	.imagecontainerone {
	  display: flex;
	  justify-content: center;
	  padding-top: 50px;
	}
	
	.navbar {
	  overflow: hidden;
	  padding-top: 100px;
	  padding-bottom: 200px;
	}
	
	.nav-list {
	  list-style-type: none; 
	  margin: 0;
	  padding: 0;
	  display: flex;
	  justify-content: center;
	  
	}
	
	.nav-item {
	  float: left; 
	  padding: 20px 30px;
	  background-color: white;
	  background: #F8FCF4;
	}
	
	.about{
		margin-top: -38px;
		font-family: Inter, Inter;
		font-weight: bold;
		font-size: 19px;
		color: #FFFFFF;
	}
	
	.content{
		margin-top: 20px;
		font-family: Inter, Inter;
		font-weight: normal;
		font-size: 13px;
		color: #606060;
	}
	
	.vertical{
		width: 4px;
		height: 123px;
		background: #BDC83F;
		border-radius: 2px;
		margin-top: 40px;
		margin-left: 30px;
	}
	
	.bgcontent{
		margin-top: -55px;
		font-family: Inter, Inter;
		font-weight: 900;
		font-size: 30px;
		color: #FFFFFF;
	}
	
	.contenbg{
		width: 971px;
		height: 123px;
		background: #FFFFFF;
		border-radius: 12px;
		position: absolute;
		margin-top: 106px;
		margin-left: 80px;
	}
	
	.downbgcontent{
		font-family: Inter, Inter;
		font-weight: 500;
		font-size: 24px;
		color: #2D2B00;
		padding-left: 34px;
		text-align: left;
		padding-top: 23px;
	}
</style>